// An API refusal code, as the gateway and the services send it. A Joi sentence or a proxy's "Internal Server Error" is not one.
export const ERROR_CODE = /^[A-Z][A-Z0-9_]+$/

// The text a screen's map gives `code`, or null when the map does not know it: a value that is not a code, an empty answer, the
// code echoed back, the map's own fallback, or a fallback that only names the code all count as unmapped.
export const mappedText = (messageForCode, code) => {
  if (typeof code !== "string" || !ERROR_CODE.test(code)) return null
  const text = messageForCode(code), probe = messageForCode("__UNMAPPED__")
  if (!text || text === code || text === probe) return null
  return typeof probe === "string" && text === probe.replace("__UNMAPPED__", code) ? null : text
}

// The mapped text of a 4xx refusal; anything else (an unmapped code, a 5xx, no answer) gets the caller's own words.
export const refusalText = (error, messageForCode, fallback) => {
  const status = error?.response?.status
  return (status >= 400 && status < 500 && mappedText(messageForCode, error.response.data?.message)) || fallback
}
